import { memo } from 'react';

import messages from '../Messages';
import { StringOrNull } from 'store/entity/types';

interface IComponentProps {
  unit: StringOrNull;
  numerator: string;
  numeratorUnit: StringOrNull;
  denominator: StringOrNull;
  denominatorUnit: StringOrNull;
}

const IndicatorFieldsViewer: React.FC<IComponentProps> = ({
  unit,
  numerator,
  denominator,
  numeratorUnit,
  denominatorUnit,
}) => {
  return (
    <span>
      <div className="input-field col s12 viewable">
        <span>{messages.numeratorLabel}</span>
        <p>
          {numerator}
          {numeratorUnit ? `(${numeratorUnit})` : ''}
        </p>
      </div>
      <div className="input-field col s12 viewable">
        <span>{messages.denominatorLabel}</span>
        <p>
          {denominator}
          {denominatorUnit ? `(${denominatorUnit})` : ''}
        </p>
      </div>
      {unit && (
        <div className="input-field col s12 viewable">
          <span>{messages.unitLabel}</span>
          <p>{unit}</p>
        </div>
      )}
    </span>
  );
};

export default memo(IndicatorFieldsViewer);
